// ThemeToggle component - Dark/Light tema degistirici
// Sun/Moon ikonlari ile tema toggle
import { Moon, Sun } from 'lucide-react'
import { useAppStore } from '../../store/useAppStore'

export default function ThemeToggle() {
  const { theme, toggleTheme } = useAppStore()

  return (
    <button
      onClick={toggleTheme}
      style={{
        width: '40px',
        height: '40px',
        borderRadius: '8px',
        border: '1px solid var(--border-color)',
        background: 'var(--card-bg)',
        color: 'var(--text-primary)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s',
      }}
      aria-label="Toggle theme"
      title={theme === 'dark' ? 'Light moda gec' : 'Dark moda gec'}
    >
      {theme === 'dark' ? (
        <Sun size={20} />
      ) : (
        <Moon size={20} />
      )}
    </button>
  )
}
